import { useState } from "react";

import "./SubCategories.css";
import "./ConfigurePanelDialog.css";
import { Category } from "./Category";

export function SubCategories({ items, onClick }) {
  const [sizeSidebar, setSizeSidebar] = useState("fullwidth");

  const resizeSidebar = () => {
    setSizeSidebar((prevSize) =>
      prevSize == "fullwidth" ? "minwidth" : "fullwidth"
    );
  };

  return (
    <div
      className={`subcategory-container ${
        sizeSidebar == "fullwidth" ? "fullwidth" : "minwidth"
      }`}
    >
      <div className="subcategory-header">
        <span className="title">SubCategory Available</span>
        <span className="icon-double-arrow icon" onClick={resizeSidebar}></span>
      </div>
      <div className="subcategory-body">
        {items.map((sub) => (
          <div
            key={`category-${sub.categoryId}`}
            className="subcategory-container-item"
          >
            <div className="subcategory-title">
              <span className={sub?.category?.iconPath + " icon"}></span>
              <span className="text">{sub?.category?.name}</span>
              {!sub.subCategories.length && (
                <span className="no-submodule">(No submodules Available)</span>
              )}
            </div>
            {sub.subCategories.length > 0 && (
              <div className="subcategory-list">
                {sub.subCategories.map((subCat) => (
                  <Category
                    key={`category-${sub.categoryId}-subcat-${subCat.id}`}
                    item={subCat}
                    onClick={() => onClick(!subCat.isSelected, subCat.id)}
                    isSubCategory={true}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
